<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="hidden">
  <section class="row bg-brown">
    <div class="col-lg-4 col-md-3 col-sm-12 pr-0">
      <div class="upload-progress-section">
        <div class="text-center">
          <div>
            <video
              src="assets/video/movie.mp4"
              width="100%"
              height=""
              controls
            ></video>
          </div>
          <div class="my-5 container">
            <p class="font14 text-grey">
              Et sint ipsum in laboris consequat tempor labore voluptate
              incididunt. Sit elit culpa aliqua fugiat ad pariatur reprehenderit
              quis. Excepteur nostrud officia nostrud exercitation aliqua.
            </p>
            <label for="file" class="btn btn-secondary btn-sm mr-3 mt-4 pt-2"
              >REUPLOAD</label
            >
            <input type="file" name="file" id="file" class="inputfile" />
          </div>
        </div>
        <div class="mt-auto container font14 text-grey">
          Allowed formats: *MOV *AVI *MPEG4
        </div>
      </div>
    </div>
    <div class="col-lg-8 col-md-3 col-sm-12 bg-white">
      <div class="container">
        <div class="my-5">
          <div class="question-box">
            <div class="mb-4">
              <h3 class="font-bold font24">Quiz</h3>
              <div
                class="mt-4 font14 font-light d-flex justify-content-between align-items-center"
              >
                <p>
                  Use the quiz creator to create a multiple choice quiz. You may
                  only have 1 quiz per lecture.
                </p>
                <button class="btn-sm btn-secondary">Add</button>
              </div>
            </div>
            <div class="question-header">
              <div class="d-flex">
                <div class="mr-4">01</div>
                <div>Which of these does not constitute a Red Flag?</div>
              </div>
              <hr />
            </div>
            <div class="px-5 pb-5 pt-0">
              <div class="question-body">
                <div class="font14 font-light">
                  <div class="my-4 d-flex">
                    <div class="mr-3 font-bold option-number active">A.</div>
                    <div>
                      It is a long established fact that a reader will be
                      distracted.
                    </div>
                  </div>
                  <div class="my-4 d-flex">
                    <div class="mr-3 font-bold option-number">B.</div>
                    <div>
                      It is a long established fact that a reader will be
                      distracted.
                    </div>
                  </div>
                  <div class="my-4 d-flex">
                    <div class="mr-3 font-bold option-number">C.</div>
                    <div>
                      It is a long established fact that a reader will be
                      distracted.
                    </div>
                  </div>
                  <div class="my-4 d-flex">
                    <div class="mr-3 font-bold option-number">D.</div>
                    <div>
                      It is a long established fact that a reader will be
                      distracted.
                    </div>
                  </div>
                </div>
                <hr />
              </div>
              <div class="mt-5 d-flex justify-content-end pb-5">
                <button class="btn-sm btn-outline-danger">Remove</button>
              </div>
              <hr />

              <div class="my-4 d-flex align-items-center">
                <div class="mr-3 font-bold option-number">A.</div>
                <div class="row w-100">
                  <div class="col-lg-8 col-sm-12">
                    <input
                      type="text"
                      class="common-input bg-white w-100"
                      placeholder="Enter Option A"
                    />
                  </div>
                  <div class="col-lg-4 col-sm-12 sm-mt">
                    <select type="text" class="common-input bg-white w-100">
                      <option value="correct">correct</option>
                      <option value="incorrect">incorrect</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="my-4 d-flex align-items-center">
                <div class="mr-3 font-bold option-number">B.</div>
                <div class="row w-100">
                  <div class="col-lg-8 col-sm-12">
                    <input
                      type="text"
                      class="common-input bg-white w-100"
                      placeholder="Enter Option B"
                    />
                  </div>
                  <div class="col-lg-4 col-sm-12 sm-mt">
                    <select type="text" class="common-input bg-white w-100">
                      <option value="correct">correct</option>
                      <option value="incorrect">incorrect</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="my-4 d-flex align-items-center">
                <div class="mr-3 font-bold option-number">C.</div>
                <div class="row w-100">
                  <div class="col-lg-8 col-sm-12">
                    <input
                      type="text"
                      class="common-input bg-white w-100"
                      placeholder="Enter Option C"
                    />
                  </div>
                  <div class="col-lg-4 col-sm-12 sm-mt">
                    <select type="text" class="common-input bg-white w-100">
                      <option value="correct">correct</option>
                      <option value="incorrect">incorrect</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="my-4 d-flex align-items-center">
                <div class="mr-3 font-bold option-number">D.</div>
                <div class="row w-100">
                  <div class="col-lg-8 col-sm-12">
                    <input
                      type="text"
                      class="common-input bg-white w-100"
                      placeholder="Enter Option D"
                    />
                  </div>
                  <div class="col-lg-4 col-sm-12 sm-mt">
                    <select type="text" class="common-input bg-white w-100">
                      <option value="correct">correct</option>
                      <option value="incorrect">incorrect</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mt-5 d-flex justify-content-between pb-5">
                <button class="btn-sm btn-outline-primary">Cancel</button>
                <button class="btn-sm btn-primary">Submit</button>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <button
            class="btn btn-outline-secondary btn-sm my-5"
            routerLink="/courses/add-course-module-three"
          >
            Add more content
          </button>
          <button
            class="btn btn-secondary btn-sm my-5"
            routerLink="/courses/add-course-module-five"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </section>
</section>
